import { render, staticRenderFns } from "./OrderPaylinkCard.vue?vue&type=template&id=4a1ed855"
import script from "./OrderPaylinkCard.vue?vue&type=script&lang=js"
export * from "./OrderPaylinkCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports